export enum CategoryTemplateViewTab {
  CATEGORIZED = "categorized",
  HISTORY = "history",
}

export enum CategoryTemplateEditTab {
  ALL = "all",
  SHOOT_TIME = "shootTime",
}
